module.exports = __webpack_public_path__ + "../resources/images/plate-fd94fa9c700c21d11deced1fb5ba0fdd.svg";